/*
 *
 * NewTreatmentPage actions
 *
 */

import {
  CHECK_AVAILABILITY,
  CONTINUE,
  CREATE_TREATMENT_PLAN,
  DEFAULT_ACTION,
  DELETE_PLANNED_TREATMENT,
  GET_PATIENT,
  GET_PATIENT_ID,
  GET_PLANNED_DAYS,
  GET_TIME_SLOT_DATA,
  GET_TREATMENT_DRIVERS,
  GET_TREATMENT_DURATION,
  GET_TREATMENT_PLAN,
  GET_TREATMENT_PLAN_ID,
  HARD_RESET,
  IS_EDITING_PLANNED_TREATMENT,
  REMOVE_PATIENT,
  SAVE_TREATMENTS,
  SELECT_TIME_SLOT,
  SELECT_UNPLANNED,
  SET_EDITING_TREATMENT,
  SET_PATIENT,
  SET_TREATMENT_PLAN,
  SET_TREATMENT_TO_PLAN,
  SOFT_RESET,
  TIME_WINDOW_ACTION,
  UPDATE_PATIENT,
  UPDATE_TREATMENT_PLAN,
  UPDATE_TREATMENT_PLAN_TREATMENT
} from "./constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getTreatmentPlan(patientId) {
  return {
    type: GET_TREATMENT_PLAN,
    patientId,
  };
}

export function updateTreatmentPlanAction(treatmentPlan, callback) {
  return {
    type: UPDATE_TREATMENT_PLAN,
    treatmentPlan,
    callback,
  };
}

export function createTreatmentPlanAction(treatmentPlan, callback) {
  return {
    type: CREATE_TREATMENT_PLAN,
    treatmentPlan,
    callback,
  };
}

export function hardResetAction() {
  return {
    type: HARD_RESET,
  };
}

export function resetAction() {
  return {
    type: SOFT_RESET,
  };
}

export function getPatientAction(patientId) {
  return {
    type: GET_PATIENT,
    patientId,
  };
}
export function updatePatientAction(patient) {
  return {
    type: UPDATE_PATIENT,
    patient,
  };
}

export function saveTreatments(treatments) {
  return {
    type: SAVE_TREATMENTS,
    treatments,
  };
}

export function selectTimeWindow(timeWindow) {
  return {
    type: TIME_WINDOW_ACTION,
    timeWindow,
  };
}

export function continueAction() {
  return {
    type: CONTINUE,
  };
}

export function setPatientAction(patient, dontSkip = true) {
  return {
    type: SET_PATIENT,
    patient,
    dontSkip,
  };
}

export function removePatientAction() {
  return {
    type: REMOVE_PATIENT,
  };
}

export function setTreatmentToPlanAction(treatment) {
  return {
    type: SET_TREATMENT_TO_PLAN,
    treatment,
  };
}

export function deletePlannedTreatment(treatment, callback) {
  return {
    type: DELETE_PLANNED_TREATMENT,
    treatment,
    callback,
  };
}

export function getPatientByIdAction(patientId) {
  return {
    type: GET_PATIENT_ID,
    patientId,
  };
}

export function getTreatmentPlanByIdAction(treatmentPlanId) {
  return {
    type: GET_TREATMENT_PLAN_ID,
    treatmentPlanId,
  };
}

export function updateTreatmentPlanTreatmentAction(treatment) {
  return {
    type: UPDATE_TREATMENT_PLAN_TREATMENT,
    treatment,
  };
}

export function getTimeSlotDataAction(timeSlotId) {
  return {
    type: GET_TIME_SLOT_DATA,
    timeSlotId,
  };
}

export function selectTimeSlot(timeSlot) {
  return {
    type: SELECT_TIME_SLOT,
    timeSlot,
  };
}

export function selectUnplannedAction(above, below) {
  return {
    type: SELECT_UNPLANNED,
    above,
    below,
  };
}

export function isEditingPlannedTreatment(isEditing) {
  return {
    type: IS_EDITING_PLANNED_TREATMENT,
    isEditing,
  };
}

export function checkAvailability(
  date,
  timeSlot,
  toPlan,
  callback,
  kptOverride = null,
  treatmentDurationCorrection,
  manufacturerOffice,
  withScanner
) {
  return {
    type: CHECK_AVAILABILITY,
    date,
    timeSlot,
    toPlan,
    callback,
    kptOverride,
    treatmentDurationCorrection,
    manufacturerOffice,
    withScanner
  };
}

export function setEditingTreatmentAction(editing) {
  return {
    type: SET_EDITING_TREATMENT,
    editing,
  };
}

export function setTreatmentPlanAction(treatmentPlan) {
  return {
    type: SET_TREATMENT_PLAN,
    treatmentPlan,
  };
}

export function getPlannedDays(date) {
  return {
    type: GET_PLANNED_DAYS,
    date,
  };
}

export function getTreatmentDrivers() {
  return {
    type: GET_TREATMENT_DRIVERS
  };
}

export function getTreatmentDuration(tpId, homeShipping) {
return {
  type: GET_TREATMENT_DURATION,
  tpId,
  homeShipping
};
}
